import React, { useEffect, useState } from "react";
import { fetchBonusHistory } from "../bonusHistory/cl_BonusHistorySlice";
import { useDispatch, useSelector } from "react-redux";
import PaginationComponent from "../common/PaginationComponent";

const MyBonusHistory = () => {
  const dispatch = useDispatch();
  const { userDetails } = useSelector((state) => state?.signIn);
  const { bonusHistoryData, bonusLoader } = useSelector(
      (state) => state?.bonusHistory
    );
  let PageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    if (userDetails?.userId) {
      dispatch(fetchBonusHistory(userDetails?.userId, currentPage - 1));
    }
  }, [userDetails?.userId, currentPage]);

  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");

    return `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`;
  };

  return (
    <>
      <div className="SB-transactionBox">
        {bonusLoader ? (
          <div className="SB-section-loader">
            <div className="SB-section-loader-container">
              <span className="SB-dot"></span>
              <span className="SB-dot"></span>
              <span className="SB-dot"></span>
              <span className="SB-dot"></span>
            </div>
          </div>
        ) : (
          bonusHistoryData?.data?.length > 0 &&
          bonusHistoryData?.data?.map((data, ind) => (
            <div className="SB-transaction-item" key={ind}>
              <div className="SB-transaction__col SB-col1">
                <div className="SB-transaction-dateID">
                  <div className="SB-transactionID">ID: {data?.id}</div>
                  <div className="SB-transactionDate">
                    {formatDate(data?.releasedDate)}
                  </div>
                </div>
              </div>
              <div className="SB-transaction__col SB-col2">
                <div className="">
                  <div className="SB-transactionType">
                    {data?.transactionType === "ROLL_OVER_BONUS" 
                      ? "Added to Cash Balance"
                      : data?.userBonusDetails?.bonusType}
                  </div>
                  <div className="SB-transactionMethod">
                    {data?.transactionType}
                  </div>
                </div>
                <div className="SB-transaction-statusAmount">
                  <div
                    className={`SB-transactionAmount ${
                      data?.transactionType === "ROLL_OVER_BONUS" 
                        ? "SB-success"
                        : "SB-error"
                    }`}
                  >
                    KES {""}
                    {data.transactionType === "UNLOCKED_BONUS_APPLIED"
                      ? data.unlockedBonus
                      : data.transactionType === "LOCKED_BONUS_APPLIED"
                      ? data.lockedBonus
                      : data.transactionType === "BONUS_UNLOCKED"
                      ? data.unlockedBonus
                      : data.transactionType === "BONUS_LOCKED"
                      ? data.lockedBonus
                      : data.amount || Math.abs(data.transactionAmount)}
                  </div>
                </div>
              </div>
            </div>
          ))
        )}
        {!bonusLoader &&
          (bonusHistoryData?.data?.length === 0 ||
            bonusHistoryData?.data?.length === undefined) && (
            <div className="SB-msgBox">
              <div className="SB-msgBox-container">
                Currently there is no data available
              </div>
            </div>
          )}
      </div>
      {!bonusLoader && (
        <PaginationComponent
          currentPage={currentPage}
          totalCount={bonusHistoryData?.totalRecords || 0}
          pageSize={PageSize}
          onPageChange={(page) => setCurrentPage(page)}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  );
};

export default MyBonusHistory;
